import { Component, OnInit } from '@angular/core'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { EVENT_NAMES } from '../../utils/events'
import type { ValidateOtpResponse } from '../../interfaces/validate-otp-response'
import type { GenerateOtpResponse } from '../../interfaces/generate-otp-response'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'app-success-layout',
  templateUrl: './success-layout.component.html',
  styleUrls: ['./success-layout.component.scss'],
})
export class SuccessLayoutComponent implements OnInit {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(private router: Router, private route: ActivatedRoute) {}

  private handleOnExit = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    this.router.navigate([flow, process], { replaceUrl: true })
  }

  ngOnInit(): void {
    window.addEventListener(EVENT_NAMES.summaryOnBack, this.handleOnExit)

    const accountData = this.storage.get(EVENT_NAMES.otpOnSubmit) as ValidateOtpResponse | undefined
    const userData = this.storage.get(EVENT_NAMES.otpOnGenerate) as GenerateOtpResponse | undefined
    const { acceptedInsurance } = this.storage.get(EVENT_NAMES.insuranceConfig) || { acceptedInsurance: false }

    this.storage.set(EVENT_NAMES.summaryConfig, {
      acceptedInsurance,
      accountData: {
        accountState: accountData?.data?.accountNumber ? 'created' : 'pending',
        accountNumber: accountData?.data?.accountNumber,
        accountType: accountData?.data?.accountType,
        email: userData?.data?.email,
        name: userData?.data?.firstName,
      },
    })
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.summaryOnBack, this.handleOnExit)
  }
}
